import router from "@/router";
import { getLoginToken, iframePost, isInIframe } from "@/utils";
import { isApp } from "@/utils/device";
import { tokenExpires } from "@/utils/starnest";
import axios from "axios";
import moment from "moment";
import { showToast } from "vant";

const initAxios = axios.create({
  timeout: 1800000//数据响应过期时间
})

//请求拦截器
initAxios.interceptors.request.use(async(config) => {

  //  h5中token过期，提前10秒刷新------
  const userInfo = localStorage.getItem('H5_MALL_USERINFO') ? JSON.parse(localStorage.getItem('H5_MALL_USERINFO') || '') : null
  const t = +new Date();
  if (userInfo && userInfo.expiresTime) {
    console.log(`token过期时间:${moment(userInfo.expiresTime).format('YYYY-MM-DD HH:mm:ss')}`);
    try {
      if (t >= userInfo.expiresTime - 10000) {
        const {
          data
        } = await axios.get(`${import.meta.env.VITE_APP_STARNEST_API}/app-api/member/auth/refresh-token` + '?refreshToken=' + userInfo.refreshToken, {
          headers: {
            Authorization: `Bearer ${userInfo.accessToken}`,
            'tenant-id': 1,
          },
        });
        console.log(data,'data---');
        
        if (data.data) {
          localStorage.setItem('H5_MALL_USERINFO',JSON.stringify(data.data))
          sessionStorage.setItem('APLINK_STARNEST_TOKEN',data.data.accessToken)
        }
        // 理论上不需要更新modal里token。modal里的token只用了account。
      }
    } catch (e: any) {
      throw `refresh Token error: ${e.message}`;
    }
  }
  //  h5中token过期，提前10秒刷新------end


  // amaxscan域名下接口附加headers会报跨域问题
  if (config.url?.includes('v1/chain')) {
    return config
  }


  //在发送之前做点什么
  if ((window as any).APLINK_STARNEST && (window as any).APLINK_STARNEST.token) {
    // 有注入APLINK_STARNEST TOKEN 在APP环境
    console.log((window as any).APLINK_STARNEST.token,'token / APP访问');
    sessionStorage.setItem('APLINK_STARNEST_TOKEN',(window as any).APLINK_STARNEST.token)
    config.headers['Authorization'] = `Bearer ${(window as any).APLINK_STARNEST.token}`;
  }else{
    // 在H5/iframe环境
    // console.log('-----H5/iframe环境-----');
    if (sessionStorage.getItem('APLINK_STARNEST_TOKEN')) {
      config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('APLINK_STARNEST_TOKEN')}`;
    }else if (localStorage.getItem('H5_MALL_USERINFO')) {
      const userInfo = JSON.parse(localStorage.getItem('H5_MALL_USERINFO') || '')
      config.headers['Authorization'] = `Bearer ${userInfo.accessToken}`;
    }
  }
  // console.log(config,'config');
  config.headers['tenant-id'] = 1;
  return config

}, (error) => {
  //对请求错误做点什么
  return error
})
function _tokenExpires() {
  if (isApp) {
    console.log('App环境 刷新token');
    // showToastContent('token过期，刷新token');
    tokenExpires();
  }else{
    router.push('/login')
  }
}

//响应拦截器
initAxios.interceptors.response.use((response) => {
  if (response.data.code) {
    const data = response.data
    console.log(data,'response.data');
    
    if ([200, 0].includes(data.code)) {
      // 正常请求返回
    } else if (data.code === 401) {
      _tokenExpires();
      if (isInIframe()) {
        console.log('iframe 环境');
        iframePost('needlogin')
      }
    } else if (data.code === 4011) {
    } else if (data.code === 1042) {
      showToast('accountPasswordError');
    } else {
      // const code = data.code.toString();
      showToast(data.msg);
    }
  }
  return response.data

  // if (response.status === 200 ) {

  //   if (response.data.code === 401) {
  //     // tokenExpires()
  //     if (isInIframe()) {
  //       iframePost('needlogin')
  //     }else{
  //       router.push('/login')
  //     }
  //   }
    
  //   return response.data
  // } else {
  //   return {resultCode: -1}
  // }
},
(error) => {
  if (axios.isCancel(error)) {
    return new Promise(() => {});
  }
  const { data } = error.response || {};
  console.log(data,'data---');
  
  if (data?.code === 401) {
    _tokenExpires();
  }
  if (data) {
    // 为了不被阻断
    return Promise.resolve(data);
  }

  return Promise.reject(error);
}
)
//导出
export default () => initAxios